import type { TextStyle } from 'react-native';
import { displayFont, uiFont } from './agapellaFonts';

/**
 * The only Nunito Sans weights shipped on Web (plus a native-only 500 for the
 * gamification scale, see agapellaFonts.ts). Use these instead of string
 * literals so a weight the faces cannot render never reappears (CORE-1118).
 */
export const fontWeights = {
  regular: '400',
  semibold: '600',
  bold: '700',
} as const;

/** Approved Agapella scale. Colours and layout belong to the consuming surface. */
const ui = (size: number, lineHeight: number, weight: 400 | 600 | 700): TextStyle => ({
  ...uiFont(weight),
  fontSize: size,
  lineHeight,
  letterSpacing: 0,
  fontStyle: 'normal',
  textTransform: 'none',
});

export const typographyTokens = {
  displayH1: { ...displayFont(), fontSize: 56, lineHeight: 64, letterSpacing: -0.56, fontStyle: 'normal', textTransform: 'none' } as TextStyle,
  displayH2: { ...displayFont(), fontSize: 40, lineHeight: 48, letterSpacing: -0.4, fontStyle: 'normal', textTransform: 'none' } as TextStyle,
  uiH1: ui(40, 48, 700),
  uiH2: ui(28, 36, 600),
  uiH3: ui(22, 28, 600),
  bodyLarge: ui(18, 28, 400),
  body: ui(16, 24, 400),
  bodyAccent: ui(16, 24, 600),
  label: ui(14, 20, 600),
  link: ui(14, 20, 600),
  caption: ui(12, 16, 400),
  /** Emphasised caption (badges, counters, small CTAs) — same face/size as error.text. */
  captionAccent: ui(12, 16, 600),
  error: ui(12, 16, 600),
  buttonPrimary: { ...ui(16, 24, 700), textAlign: 'center' } as TextStyle,
  buttonSecondary: { ...ui(16, 24, 600), textAlign: 'center' } as TextStyle,
  input: ui(16, 24, 400),
  navigation: ui(16, 24, 600),
};
